import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-dimensions',
  templateUrl: './custom-sources-badge-dimensions.component.html',
  styleUrls: ['./custom-sources-badge-dimensions.component.scss']
})
export class CustomSourcesBadgeDimensionsComponent {
  @Input() public datasource: DatasetUsageComponentObject;
}
